export default __webpack_public_path__ + "static/media/img-s4-video-left.62ff7a9d.png";